import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "shell"]

  toggle() {
    const expanded = this.buttonTarget.getAttribute("aria-expanded") === "true"
    this.buttonTarget.setAttribute("aria-expanded", String(!expanded))
    this.shellTarget.classList.toggle("is-menu-open", !expanded)
  }
}
